import { Suspense } from 'react'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import ErrorMessage from '@components/ErrorBoundary/ErrorMessage'
import Loader from '@components/Loader/Loader'
import CompanyData from './CompanyData'

import './Company.css'

export default function Company() {
  return (
    <div id="company" className="page">
      <ErrorBoundary errorComponent={ErrorMessage}>
        <Suspense fallback={<Loader />}>
          <CompanyData />
        </Suspense>
      </ErrorBoundary>
    </div>
  )
}
